import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { useCompaniesOptions } from '../../../../hooks/useCompaniesOptions';
import BlockedUnregisteredUsersApi from '../../../../api/blockedUnregisteredUsers';

const BlockedUnregisteredUserFormModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    phoneNumber: '',
    companyId: '',
    firstName: '',
    lastName: '',
    govId: '',
    empId: '',
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const { companiesOptions } = useCompaniesOptions({ showAll: false });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleClose = () => {
    setFormData({ phoneNumber: '', companyId: '', firstName: '', lastName: '', govId: '', empId: '' });
    onClose();
  };

  const handleSubmit = async () => {
    if (!formData.phoneNumber.trim()) {
      toast({ title: 'נדרש מספר טלפון', status: 'error', duration: 3000, isClosable: true });
      return;
    }
    if (!formData.companyId) {
      toast({ title: 'נדרש לבחור חברה', status: 'error', duration: 3000, isClosable: true });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        phoneNumber: formData.phoneNumber.trim(),
        companyId: Number(formData.companyId),
        ...(formData.firstName.trim() && { firstName: formData.firstName.trim() }),
        ...(formData.lastName.trim() && { lastName: formData.lastName.trim() }),
        ...(formData.govId.trim() && { govId: formData.govId.trim() }),
        ...(formData.empId.trim() && { empId: formData.empId.trim() }),
      };
      await BlockedUnregisteredUsersApi.create(payload);
      toast({ title: 'משתמש חסום נוצר בהצלחה', status: 'success', duration: 3000, isClosable: true });
      onSuccess();
      handleClose();
    } catch (err) {
      toast({ title: 'שגיאה ביצירת משתמש חסום', status: 'error', duration: 3000, isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton position="absolute" left="8px" right="auto" top="8px" zIndex="3" />
        <ModalHeader>צור משתמש חסום לא רשום</ModalHeader>
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>חברה</FormLabel>
              <Select
                placeholder="בחר חברה"
                value={formData.companyId}
                onChange={(e) => handleChange('companyId', e.target.value)}
              >
                {companiesOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl isRequired>
              <FormLabel>מספר טלפון</FormLabel>
              <Input
                placeholder="05XXXXXXXX"
                value={formData.phoneNumber}
                onChange={(e) => handleChange('phoneNumber', e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>שם פרטי</FormLabel>
              <Input
                value={formData.firstName}
                onChange={(e) => handleChange('firstName', e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>שם משפחה</FormLabel>
              <Input
                value={formData.lastName}
                onChange={(e) => handleChange('lastName', e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>תעודת זהות</FormLabel>
              <Input
                value={formData.govId}
                onChange={(e) => handleChange('govId', e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>מזהה עובד</FormLabel>
              <Input
                value={formData.empId}
                onChange={(e) => handleChange('empId', e.target.value)}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose}>
            ביטול
          </Button>
          <Button colorScheme="red" onClick={handleSubmit} isLoading={loading}>
            צור משתמש חסום
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BlockedUnregisteredUserFormModal;
